import type { NormalizedStorageObject } from "../../../../services/api/instances/storageApi/types/object_types";
import type { StorageObjectValue } from "../../../../services/api/instances/storageApi/types/service_types";

export const findNextNavigableObject = (
  ids: string[],
  entities: Record<string, NormalizedStorageObject<StorageObjectValue>>,
  deletedId: string,
): string | null => {
  const deletedObject = entities[deletedId];
  const parentId = deletedObject?.parentId;

  if (parentId) {
    const parent = entities[parentId];
    const siblings = parent.childrenIds.filter((id) => id !== deletedId);

    return siblings.length > 0 ? siblings[siblings.length - 1] : parent.id;
  }

  const rootSiblings = ids.filter(
    (id) =>
      id !== deletedId &&
      (!entities[id]?.parentId || entities[id]?.parentId === deletedId),
  );

  if (rootSiblings.length === 0) {
    return null;
  }

  const lastRootSibling = entities[rootSiblings[rootSiblings.length - 1]];

  if (lastRootSibling.childrenIds && lastRootSibling.childrenIds.length > 0) {
    return lastRootSibling.childrenIds[lastRootSibling.childrenIds.length - 1];
  }

  return lastRootSibling.id;
};
